import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import { AccountComponent } from '../components/account.component';
import { accounts } from '../../../../../../redux/accounts/action';
import { selectAccountsListItems, selectAccountsQueryItems } from '../../../../../../redux/accounts/selector';
import { selectAccountTypesListItems } from '../../../../../../redux/account-types/selector';
import { accountTypes } from '../../../../../../redux/account-types/action';
import { toast } from 'react-toastify';
import { deepCopy } from '../../../../../../common/services/common.service';
import { settings } from '../../../../../../redux/settings/actions';
import { selectBrandMappingsQueryItems, selectBrandMappingsListItems } from '../../../../../../redux/brand-mappings/selector';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import UploadFiles from '../../../../../../models/UploadFile';
import { brandMappings as accountBrandMappings } from '../../../../../../redux/brand-mappings/action';

let currentChange: any = {}
const OWNER_TYPE_ACCOUNT = 68

const ManagementAccount = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useSelector(selectCurrent)
  const accountsQuery = useSelector(selectAccountsQueryItems)
  const accountListItems = useSelector(selectAccountsListItems)
  const accountTypeListItems = useSelector(selectAccountTypesListItems)
  const accountsBrandMappingsQuery = useSelector(selectBrandMappingsQueryItems)
  const listBrandMappingsData = useSelector(selectBrandMappingsListItems)

  const librariesItems = storePersist?.get("library")?.current;
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const organizationUnitsItems = useSelector(selectOrganizationUnitsListItems)
  const [selectedAccounts, setSelectedAccounts] = useState<any>([])
  const [selectedAddress, setSelectedAddress] = useState<any>({
    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })
  const [selectMappedAccountTypes, setSelectMappedAccountTypes] = useState<any>({
    MappedAccountTypes: {
      MappedAccountTypeIds: []
    }
  })
  const [logoFiles, setLogoFiles] = useState<any>([])
  const [favFiles, setFavFiles] = useState<any>([])
  const [socialProfiles, setSocialProfiles] = useState([])
  const [brandMappings, setBrandMappings] = useState<any>([])
  const [openFile, setOpenFile] = useState<any>([]);
  const [openConfirmationFile, setOpenConfirmationFile] = React.useState(false);
  const [openConfirmationLogoFile, setOpenConfirmationLogoFile] = React.useState(false);
  const [openConfirmationFavFile, setOpenConfirmationFavFile] = React.useState(false);
  const [openImageFile, setOpenImageFile] = useState<any>([]);

  const fetchAccountsQueryById = async () => {
    await dispatch(accounts.resetAction({ actionType: 'query' }))
    await dispatch(accounts.query({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/query`,
      entity: 'accounts',
      jsonData:
      {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const listBrandMappings = () => {
    dispatch(accountBrandMappings.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/brand-mappings/list`,
      entity: 'brandMappings',
      jsonData: {
      }
    }))
  }

  const fetchBrandMappingsQueryById = () => {
    dispatch(accountBrandMappings.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/brand-mappings/query`,
      entity: 'brandMappings',
      jsonData: {
        Records: [
          {
            OwnerTypeId: OWNER_TYPE_ACCOUNT,
            OwnerId: parmas?.id,
            Id: 0,
          }
        ]
      }
    }))
  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedAccounts({ ...selectedAccounts, [field]: event })
  }

  const onInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }
    setSelectedAccounts({ ...selectedAccounts, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });

    setSelectMappedAccountTypes({ ...selectMappedAccountTypes, [fields[0]]: value });
  }

  const handleFormLogoItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Logos);
    items[idx] = { ...items[idx], [field]: value };
    setLogoFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Logos: items };
    setBrandMappings(updatedCardValue);
  }
  const handleFormFavItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Favicons);
    items[idx] = { ...items[idx], [field]: value };
    setFavFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Favicons: items };
    setBrandMappings(updatedCardValue);
  }
  const handleFormSocialProfileItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(socialProfiles);
    let item = items[idx];
    item = { ...item, [field]: value }
    items[idx] = item;
    currentChange = { value, field, idx }
    setSocialProfiles(items);
  }

  // const handleInnerFormChange: any = (event: any, field: string, data: any) => {
  //   const fields = R.split(
  //     '.',
  //     field
  //   );
  //   const value = { ...data, [fields[1]]: event }// inner data update
  //   setSelectedOrganizationUnit({ ...selectedOrganizationUnit, [fields[0]]: value });
  //   setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  // }


  const handleFormItemBrandChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(brandMappings);
    let item = items[idx];
    item = { ...item, [field]: value }
    items[idx] = item;
    currentChange = { value, field, idx }
    setBrandMappings(items);
  }

  const handleClose = () => {
    if (openConfirmationFile) {
      setOpenConfirmationFile(false)
    } else if (openConfirmationLogoFile) {
      setOpenConfirmationLogoFile(false)
    } else if (openConfirmationFavFile) {
      setOpenConfirmationFavFile(false)
    }
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  const addNewRow = ({ selectedBrandsArg }: any) => {
    const localSelectedBrands = deepCopy(selectedBrandsArg)
    const newsBrand = {
      Id: 0,
      Name: '',
      Description: '',
      Logos: [
        {
          Url: '',
          Size: '',
          Background: '',
        }
      ],
      Favicons: [
        {
          Url: '',
          Size: '',
          Background: '',
        }
      ],
      Branding: {
        Primary: {},
        Secondary: {},
        Tertiary: {},
        Ghost: {}
      }
    }
    if (localSelectedBrands.length === 0 ||
      localSelectedBrands[localSelectedBrands?.length - 1]?.Name !== ''
    ) {
      localSelectedBrands?.push(newsBrand);
    }

    return localSelectedBrands
  }

  const addNewLogoFilesRow = ({ selectedLogoFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedlogo = deepCopy(selectedLogoFilesArg)
    const newSelectedLogo = {
      Url: '',
      Size: '',
      Background: '',
    }

    if (localSelectedlogo.length === 0 ||
      brandMapping[idx1]?.Logos[brandMapping[idx1].Logos?.length - 1]?.Url !== ''
    ) {

      brandMapping[idx1]?.Logos?.push(newSelectedLogo)
    }

    return localSelectedlogo
  }

  const addNewFavFilesRow = ({ selectedFavFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedfav = deepCopy(selectedFavFilesArg)
    const newSelectedFav = {
      Url: '',
      Size: '',
      Background: '',
    }

    if (localSelectedfav.length === 0 ||
      brandMapping[idx1]?.Favicons[brandMapping[idx1].Favicons?.length - 1]?.Url !== ''
    ) {

      brandMapping[idx1]?.Favicons?.push(newSelectedFav)
    }

    return localSelectedfav
  }

  const setCombinationLogoInfo = async () => {
    let localSelectedLogo = deepCopy(logoFiles)
    localSelectedLogo.splice(
      currentChange.idx,
      1,
      { ...localSelectedLogo[currentChange.idx] }
    );
    localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: localSelectedLogo, brandMapping: brandMappings, idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setLogoFiles(localSelectedLogo)
  }
  const setCombinationFavInfo = async () => {
    let localSelectedFav = deepCopy(favFiles)
    localSelectedFav.splice(
      currentChange.idx,
      1,
      { ...localSelectedFav[currentChange.idx] }
    );
    localSelectedFav = addNewFavFilesRow({ selectedFavFilesArg: localSelectedFav, brandMapping: brandMappings, idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setFavFiles(localSelectedFav)
  }

  const setCombinationBrandInfo = async () => {
    let localSelectedbrands = deepCopy(brandMappings)
    localSelectedbrands.splice(
      currentChange.idx,
      1,
      { ...localSelectedbrands[currentChange.idx] }
    );
    localSelectedbrands = addNewRow({ selectedBrandsArg: localSelectedbrands });
    currentChange.field = 'NameDONE'
    setBrandMappings(localSelectedbrands)
  }


  useEffect(
    () => {
      if (currentChange.field === 'Url') {
        setCombinationLogoInfo()
      }
    },
    [currentChange.field, currentChange.idx]
  )

  useEffect(
    () => {
      if (currentChange.field === 'Url') {
        setCombinationFavInfo()
      }
    },
    [currentChange.field, currentChange.idx]
  )

  useEffect(
    () => {
      if (currentChange.field === 'Name') {
        setCombinationBrandInfo()
      }
    },
    [brandMappings]
  )

  // const deleteSelectedMedia = async (Item: any, index: any) => {

  //   if (Item.Id === 0) {
  //     mediaFiles?.splice(
  //       index,
  //       1
  //     )
  //   }
  //   handleClose()
  // }

  const handleSubmit = (data: any) => {
    // mediaFiles[organizationUnitImageIndex].FileMappingURL = data
    // const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    // setMediaFiles(localSelectedMedia)
  }

  const changeImage = (idx: number, templateField: any, fileType: any) => {
    // setOrganizationUnitImageIndex(idx)
    // dispatch(settings.set({ getUploadFiles: 'open' }))
    // setOpenConfirmationFile(true)
    // setOpenFile({
    //   currentFileSrc: mediaFiles[idx][templateField],
    //   folder: 'Organizationunit',
    //   type: fileType
    // })
  }

  const handleLogoSubmit = (data: any) => {

    const newLogoFiles = [...logoFiles];
    const logosArray = brandMappings[currentChange.idx1]?.Logos;
    logosArray[currentChange.idx].Url = data;
    const localSelectedLogo = addNewLogoFilesRow({
      selectedLogoFilesArg: newLogoFiles,
      brandMapping: brandMappings,
      idx: currentChange.idx,
      idx1: currentChange.idx1,
      data: data
    });
    setLogoFiles(localSelectedLogo)
  }

  const changeLogoImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationLogoFile(true)
    setOpenImageFile({
      currentFileSrc: brandMaping[idx1]?.Logos[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
    currentChange = { idx, templateField, idx1 }

  }

  const changeFavImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationFavFile(true)
    setOpenImageFile({
      currentFileSrc: brandMaping[idx1]?.Favicons[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
    currentChange = { idx, templateField, idx1 }

  }

  const handleFavSubmit = (data: any) => {

    const newfavFiles = [...favFiles];
    const favsArray = brandMappings[currentChange.idx1]?.Favicons;
    favsArray[currentChange.idx].Url = data;
    const localSelectedFav = addNewFavFilesRow({
      selectedFavFilesArg: newfavFiles,
      brandMapping: brandMappings,
      idx: currentChange.idx,
      idx1: currentChange.idx1,
      data: data
    });
    setFavFiles(localSelectedFav)
  }

  useEffect(
    () => {
      dispatch(organizationUnits.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,
        entity: 'organizationUnits',
        jsonData: {}
      })).then(() => {
        dispatch(accountTypes.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
          entity: 'accountTypes',
          jsonData: {}
        }))
      }).then(() => {
        if (parmas?.id > 0) {
          fetchAccountsQueryById()
          fetchBrandMappingsQueryById()
          listBrandMappings();
        } else {
          const localSelectedBrands = addNewRow({ selectedBrandsArg: brandMappings });
          setBrandMappings(localSelectedBrands)
          const localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: logoFiles, brandMapping: brandMappings, idx1: 0 });
          setLogoFiles(localSelectedLogo)
          setIsLoading(false)
        }
      })

    },
    []
  )

  useEffect(() => {
    if (isQuery && accountsQuery?.isSuccess) {
      setSelectedAccounts(accountsQuery?.result?.items)
      setSelectedAddress({
        PrimaryAddress: accountsQuery?.result?.items?.AccountAddress?.PrimaryAddress,
        BillingAddress: accountsQuery?.result?.items?.AccountAddress?.BillingAddress,
        ShippingAddress: accountsQuery?.result?.items?.AccountAddress?.ShippingAddress
      })
      setSelectMappedAccountTypes({
        MappedAccountTypes: accountsQuery?.result?.items?.AccountInfo?.MappedAccountTypes,
      }
      )
      setIsLoading(false)
    }
    else if (!accountsQuery?.isSuccess) {
      setIsLoading(false)
    }
  }, [isQuery]
  )
  useEffect(() => {
    let brandMappings: any = null
    if (accountsBrandMappingsQuery?.result?.items) {
      brandMappings = [accountsBrandMappingsQuery?.result?.items?.Configurations]
    }
    let brandData: any = brandMappings?.map((item: any) => {
      const itemData = {
        Id: item?.Id,
        Name: item?.Name,
        Description: item?.Description,
        PrimaryColor: item?.Branding?.Primary?.Color,
        PrimaryBackgroundColor: item?.Branding?.Primary?.BackgroundColor,
        PrimaryBackgroundImage: item?.Branding?.Primary?.BackgroundImage,
        SecondaryColor: item?.Branding?.Secondary?.Color,
        SecondaryBackgroundColor: item?.Branding?.Secondary?.BackgroundColor,
        SecondaryBackgroundImage: item?.Branding?.Secondary?.BackgroundImage,
        TertiaryColor: item?.Branding?.Tertiary?.Color,
        TertiaryBackgroundColor: item?.Branding?.Tertiary?.BackgroundColor,
        TertiaryBackgroundImage: item?.Branding?.Tertiary?.BackgroundImage,
        GhostColor: item?.Branding?.Ghost?.Color,
        GhostBackgroundColor: item?.Branding?.Ghost?.BackgroundColor,
        GhostBackgroundImage: item?.Branding?.Ghost?.BackgroundImage,
        Logos: item?.Logos?.map((logoItem: any) => {
          return {
            Url: logoItem.Url,
            Size: logoItem.Size,
            Background: logoItem.Background,
          };
        }),
        Favicons: item?.Favicons?.map((favItem: any) => {
          return {
            Url: favItem.Url,
            Size: favItem.Size,
            Background: favItem.Background,
          };
        }),
      }
      return itemData
    })


    if (!brandData) {
      brandData = []
    }

    const localSelectedbrands = addNewRow({ selectedBrandsArg: brandData });
    setBrandMappings(localSelectedbrands)

    const updatedLogo = brandData.map((brandMapping: any, index: any) => {
      const localSelectedlogo = addNewLogoFilesRow({
        selectedLogoFilesArg: brandMapping?.Logos,
        brandMapping: localSelectedbrands,
        idx: brandMapping?.Logos?.length,
        idx1: index
      });
      return localSelectedlogo;
    });

    setLogoFiles(updatedLogo)
    const updatedFav = brandData.map((brandMapping: any, index: any) => {
      const localSelectedlogo = addNewFavFilesRow({
        selectedFavFilesArg: brandMapping.Favicons,
        brandMapping: localSelectedbrands,
        idx: brandMapping.Favicons.length,
        idx1: index
      });
      return localSelectedlogo;
    });
    setFavFiles(updatedFav)
  }, [accountsBrandMappingsQuery]);

  useEffect(() => {
    console.log('changing brandMappings', brandMappings)
  }, [brandMappings]);

  useEffect(() => {
    console.log('listBrandMappingsData', listBrandMappingsData)
  }, [listBrandMappingsData]);

  const createAccountBrandMapping = async () => {
    await dispatch(accountBrandMappings.resetAction({ actionType: 'create' }))
    await dispatch(accountBrandMappings.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/brand-mappings`,
      entity: 'brandMappings',
      jsonData: {
        "Records": [
          {
            OwnerTypeId: OWNER_TYPE_ACCOUNT,
            OwnerId: parmas?.id,
            "Name": brandMappings[0].Name,
            "Description": brandMappings[0].Description,
          }
        ]
      }
    }))
  }

  const updateBrandMappings = async () => {

    brandMappings.splice(
      brandMappings.length - 1,
      1
    )
    const brandData: any = brandMappings.map((item: any) => {
      if (item?.Logos?.length) {
        item.Logos.splice(item.Logos.length - 1, 1);
      }
      if (item?.Favicons?.length) {
        item.Favicons.splice(item.Favicons.length - 1, 1);
      }
      const itemData = {
        Id: accountsBrandMappingsQuery?.result?.items?.Id,
        OwnerTypeId: OWNER_TYPE_ACCOUNT,
        OwnerId: parmas?.id,
        Name: item?.Name,
        Description: item?.Description,
        Configurations: {
          Logos: item?.Logos?.map((logoItem: any) => {
            return {
              Url: logoItem.Url,
              Size: logoItem.Size,
              Background: logoItem.Background,
            };
          }),
          Favicons: item?.Favicons?.map((favItem: any) => {
            return {
              Url: favItem.Url,
              Size: favItem.Size,
              Background: favItem.Background,
            };
          }),
          Branding: {
            Primary: {
              Color: item?.PrimaryColor,
              BackgroundColor: item?.PrimaryBackgroundColor,
              BackgroundImage: item?.PrimaryBackgroundImage
            },
            Secondary: {
              Color: item?.SecondaryColor,
              BackgroundColor: item?.SecondaryBackgroundColor,
              BackgroundImage: item?.SecondaryBackgroundImage
            },
            Tertiary: {
              Color: item?.TertiaryColor,
              BackgroundColor: item?.TertiaryBackgroundColor,
              BackgroundImage: item?.TertiaryBackgroundImage
            },
            Ghost: {
              Color: item?.GhostColor,
              BackgroundColor: item?.GhostBackgroundColor,
              BackgroundImage: item?.GhostBackgroundImage
            },

          },
        }

      }
      return itemData
    })


    await dispatch(accountBrandMappings.resetAction({ actionType: 'update' }))
    await dispatch(accountBrandMappings.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/brand-mappings`,
      entity: 'brandMappings',
      jsonData: {
        Records: brandData
      }
    }))
  }


  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    // await createAccountBrandMapping();
    const mappedAccounts = selectedAccounts?.AccountInfo;

    const accountCreateItemData = {


      LoginInfo: {
        Email: selectedAccounts?.LoginInfo?.Email || '',
        PhoneNumber: selectedAccounts?.LoginInfo?.PhoneNumber || '',
        Password: selectedAccounts?.LoginInfo?.Password || '',
      },
      UserInfo: {
        Salutation: selectedAccounts?.UserInfo?.Salutation || 0,
        FirstName: selectedAccounts?.UserInfo?.FirstName || '',
        LastName: selectedAccounts?.UserInfo?.LastName || '',
      },
      AccountInfo: {
        Name: selectedAccounts?.AccountInfo?.Name || '',
        BusinessTypeId: selectedAccounts?.AccountInfo?.BusinessTypeId || 0,
        IndustryTypeId: selectedAccounts?.AccountInfo?.IndustryTypeId || 0,
        AccountSourceId: selectedAccounts?.AccountInfo?.AccountSourceId || 0,
        AnnualRevenue: selectedAccounts?.AccountInfo?.AnnualRevenue || 0,
        Description: selectedAccounts?.AccountInfo?.Description || '',
        OperatingHoursId: selectedAccounts?.AccountInfo?.OperatingHoursId || 0,
        ParentId: selectedAccounts?.AccountInfo?.ParentId || 0,
        PhotoUrl: selectedAccounts?.AccountInfo?.PhotoUrl || '',
        TypeId: selectedAccounts?.AccountInfo?.TypeId || 0,
        Website: selectedAccounts?.AccountInfo?.Website || '',
        YearStarted: selectedAccounts?.AccountInfo?.YearStarted || '',
        IsPersonAccount: selectedAccounts?.AccountInfo?.IsPersonAccount || false,
        PersonLeadSourceId: selectedAccounts?.AccountInfo?.PersonLeadSourceId || 0,
        IsCustomerPortalEnabled: selectedAccounts?.AccountInfo?.IsCustomerPortalEnabled || false,
        IsVendorPortalEnabled: selectedAccounts?.AccountInfo?.IsVendorPortalEnabled || false,
        IsPartnerEnabled: selectedAccounts?.AccountInfo?.IsPartnerEnabled || false,
        IsAccountVerified: selectedAccounts?.AccountInfo?.IsAccountVerified || false,
        IsGuestAccessEnabled: selectedAccounts?.AccountInfo?.IsGuestAccessEnabled || false,
        IsLimitedToOrganizationUnit: selectedAccounts?.AccountInfo?.IsLimitedToOrganizationUnit || false,
        FSSAI_License_Number: selectedAccounts?.AccountInfo?.FSSAI_License_Number || '',
        DisplayName: selectedAccounts?.AccountInfo?.DisplayName,
        EnableOnNetworkLogisticsSupport: selectedAccounts?.AccountInfo?.EnableOnNetworkLogisticsSupport || false,
        MappedAccountTypes: selectMappedAccountTypes?.MappedAccountTypes || {},
      },
      AccountAddress: {
        AddressBookId: selectedAddress?.AddressBookId || 0,
        PrimaryAddress: selectedAddress?.PrimaryAddress || {},
        IsUsePrimaryAddressAsBillingAddress: selectedAccounts?.IsUsePrimaryAddressAsBillingAddress || false,
        BillingAddress: selectedAddress?.BillingAddress || {},
        IsUsePrimaryAddressAsShippingAddress: selectedAccounts?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress || {},
      },
    }

    const accountItemData = {


      Id: selectedAccounts?.Id || 0,
      IsActive: selectedAccounts?.IsActive || false,
      LoginInfo: {
        Email: selectedAccounts?.LoginInfo?.Email || '',
        PhoneNumber: selectedAccounts?.LoginInfo?.PhoneNumber || '',
        Password: selectedAccounts?.LoginInfo?.Password || '',
      },
      UserInfo: {
        Salutation: selectedAccounts?.UserInfo?.Salutation || 0,
        FirstName: selectedAccounts?.UserInfo?.FirstName || '',
        LastName: selectedAccounts?.UserInfo?.LastName || '',
      },
      AccountInfo: {
        Name: selectedAccounts?.AccountInfo?.Name || '',
        BusinessTypeId: selectedAccounts?.AccountInfo?.BusinessTypeId || 0,
        IndustryTypeId: selectedAccounts?.AccountInfo?.IndustryTypeId || 0,
        AccountSourceId: selectedAccounts?.AccountInfo?.AccountSourceId || 0,
        AnnualRevenue: selectedAccounts?.AccountInfo?.AnnualRevenue || 0,
        Description: selectedAccounts?.AccountInfo?.Description || '',
        OperatingHoursId: selectedAccounts?.AccountInfo?.OperatingHoursId || 0,
        ParentId: selectedAccounts?.AccountInfo?.ParentId || 0,
        PhotoUrl: selectedAccounts?.AccountInfo?.PhotoUrl || '',
        TypeId: selectedAccounts?.AccountInfo?.TypeId || 0,
        Website: selectedAccounts?.AccountInfo?.Website || '',
        YearStarted: selectedAccounts?.AccountInfo?.YearStarted || '',
        IsPersonAccount: selectedAccounts?.AccountInfo?.IsPersonAccount || false,
        PersonLeadSourceId: selectedAccounts?.AccountInfo?.PersonLeadSourceId || 0,
        IsCustomerPortalEnabled: selectedAccounts?.AccountInfo?.IsCustomerPortalEnabled || false,
        IsVendorPortalEnabled: selectedAccounts?.AccountInfo?.IsVendorPortalEnabled || false,
        IsPartnerEnabled: selectedAccounts?.AccountInfo?.IsPartnerEnabled || false,
        IsAccountVerified: selectedAccounts?.AccountInfo?.IsAccountVerified || false,
        IsGuestAccessEnabled: selectedAccounts?.AccountInfo?.IsGuestAccessEnabled || false,
        IsLimitedToOrganizationUnit: selectedAccounts?.AccountInfo?.IsLimitedToOrganizationUnit || false,
        FSSAI_License_Number: selectedAccounts?.AccountInfo?.FSSAI_License_Number || '',
        DisplayName: selectedAccounts?.AccountInfo?.DisplayName,
        EnableOnNetworkLogisticsSupport: selectedAccounts?.AccountInfo?.EnableOnNetworkLogisticsSupport || false,
        MappedAccountTypes: selectMappedAccountTypes?.MappedAccountTypes || {},
      },
      GSTInfo: {
        GSTNumber: selectedAccounts?.GSTInfo?.GSTNumber || '',
        PANNumber: selectedAccounts?.GSTInfo?.PANNumber || '',
        GSTTypeId: selectedAccounts?.GSTInfo?.GSTTypeId || 0,
        GSTRegistrationTypeId: selectedAccounts?.GSTInfo?.GSTRegistrationTypeId || 0,
      },
      BankAccountInfo: {
        BankAccountHolderName: selectedAccounts?.BankAccountInfo?.BankAccountHolderName || '',
        IFSC_Code: selectedAccounts?.BankAccountInfo?.IFSC_Code || '',
        BankAccountNumber: selectedAccounts?.BankAccountInfo?.BankAccountNumber || ''
      },
      AccountAddress: {
        AddressBookId: selectedAddress?.AddressBookId || 0,
        PrimaryAddress: selectedAddress?.PrimaryAddress || {},
        IsUsePrimaryAddressAsBillingAddress: selectedAccounts?.IsUsePrimaryAddressAsBillingAddress || false,
        BillingAddress: selectedAddress?.BillingAddress || {},
        IsUsePrimaryAddressAsShippingAddress: selectedAccounts?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress || {},
      },
      LimitedToOrganizationUnitMappings: {
        LimitedToOrganizationUnitIds: selectedAccounts?.LimitedToOrganizationUnitMappings?.LimitedToOrganizationUnitIds || []
      }

    }

    if (parmas?.id > 0) {
      await dispatch(accounts.resetAction({ actionType: 'update' }))
      await dispatch(accounts.update({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts`,
        entity: 'accounts',
        jsonData: {
          Context: {},
          Records: [
            accountItemData
          ]
        }
      }))

      await updateBrandMappings();
      back()

    } else if (selectedAccounts?.LoginInfo?.Password === selectedAccounts?.LoginInfo?.ConfirmPassword) {
      await dispatch(accounts.resetAction({ actionType: 'create' }))
      await dispatch(accounts.create({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts`,
        entity: 'accounts',
        jsonData: {
          Context: {},
          Records: [
            accountCreateItemData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      toast.error("Password and Confirm Password must be same.")
    }

  }

  const back = () => {
    navigate('/management/organization/rms/accounts')
  }

  return (
    <>
      {getUploadFiles == 'open' && openConfirmationFile && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {getUploadFiles == 'open' && openConfirmationLogoFile && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openImageFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleLogoSubmit}
        type={openImageFile?.type}
        ownerId={parmas?.id}
      />}
      {getUploadFiles == 'open' && openConfirmationFavFile && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openImageFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleFavSubmit}
        type={openImageFile?.type}
        ownerId={parmas?.id}
      />}
      {isLoading ? <PageLoader /> :
        <AccountComponent
          id={parmas?.id}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          salutation={librariesItems?.Salutation}
          businessType={librariesItems?.BusinesType}
          industryType={librariesItems?.IndustryType}
          accountSource={librariesItems?.AccountSource}
          accounts={accountListItems?.result?.items}
          typeId={librariesItems?.Type}
          accountType={accountTypeListItems?.result?.items}
          operatingHours={librariesItems?.OperatingHours}
          gstRegistrationType={librariesItems?.GSTRegistrationType}
          gstType={librariesItems?.GSTType}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onInnerFormChange={onInnerFormChange}
          organizationUnits={organizationUnitsItems?.result?.items}
          selectedAddress={selectedAddress}
          selectedAccounts={selectedAccounts}

          onFormFavItemChange={handleFormFavItemChange}
          changeFavImage={changeFavImage}
          logoFiles={logoFiles}
          onFormLogoItemChange={handleFormLogoItemChange}
          faviconSize={librariesItems.FaviconSize}
          changeLogoImage={changeLogoImage}
          logoBackground={librariesItems.LogoBackground}
          onFormItemBrandChange={handleFormItemBrandChange}
          brandMappings={brandMappings}
          fileTypes={librariesItems.FileType}
          changeImage={changeImage}
          currencyRoundingType={librariesItems.RoundingType}
          currencyCodeType={librariesItems.CurrencyCodeType}
          selectMappedAccountTypes={selectMappedAccountTypes}
        />
      }
    </>
  )

}

export default ManagementAccount;